import tw from "tailwind-styled-components";

export const FormContainer = tw.div`
max-w-7xl w-full h-full
flex flex-col p-5 gap-5 relative
`;

export const Path = tw.div`
font-Roboto font-semibold 
text-sm text-gray-400
`;

export const NavbarContainer = tw.div`
flex items-center justify-between
`;

export const TittleContainer = tw.div`
flex gap-5 items-center
`;

export const NavbarTitle = tw.h1`
font-bold text-[#0052A2] text-xl
`;

export const Form = tw.form`
h-screen overflow-auto pr-3 pb-5
flex flex-col gap-4 
`;

export const Section = tw.div`
flex flex-col gap-5 w-auto rounded-xl bg-white
shadow-gray-300 shadow-custom m-3 p-5
`;

export const SectionTitle = tw.label`
w-full h-fit p-2 uppercase
text-center text-sm font-bold text-[#616161] font-Roboto
border-b-2 border-[#EEEEEE] 
`;

export const SectionContainer = tw.div`
grid grid-cols-1 lg:grid-cols-2 gap-4
`;

export const ColumnContainer = tw.div`
flex flex-col gap-3
`;

export const InputContainer = tw.div`
flex flex-col gap-3
`;

export const InputLabel = tw.label`
font-semibold text-slate-900 text-base
`;

export const Input = tw.input`
border-2 border-[#DFE5EF] py-2 focus:outline-none 
rounded-lg p-2 px-5 hover:border-[#1C93FF] focus:border-[#1C93FF]
`;

export const Error = tw.label`
text-red-800 text-sm text-center
`;

export const Button = tw.button`
bg-[#0052A2] text-white font-semibold py-2 px-4 rounded-md hover:bg-[#1C93FF]
`;
